export default {
  'navbar.home': 'Inicio',
  'navbar.explore': 'Explorar',
  'navbar.favorites': 'Favoritos',
  'navbar.messages': 'Mensajes',
  'navbar.login': 'Iniciar sesión',
  'navbar.register': 'Registrarse',
  'navbar.about': 'Acerca de',
  'navbar.how_it_works': 'Cómo funciona',
  'navbar.pricing': 'Precios',
  'navbar.blog': 'Blog',
  'navbar.support': 'Soporte',
  'navbar.dashboard': 'Panel de control',
  'navbar.admin': 'Administración',
  'navbar.logout': 'Cerrar sesión',
  'navbar.brand': 'Pink Paradise',
  'navbar.toggle_theme': 'Cambiar tema',
  'navbar.change_language': 'Cambiar idioma'
};
